const defaultSchoolTypes = [
  { id: 'state', name: 'دولتی' },
  { id: 'private', name: 'خصوصی' },
  { id: 'trustees', name: 'هیات امنایی' },
  { id: 'special', name: 'خاص' },
  { id: 'shahed', name: 'شاهد' },
  { id: 'boarding', name: 'شبانه روزی' },
  { id: 'nodet', name: 'استعداد درخشان' },
  { id: 'abroad', name: 'خارج از کشور' },
]

export const defaultState = {
  auth: { authenticated: false, userType: undefined },
  sidebar: { isOpen: true },
  profile: { aSyncCall: false, userInfo: {}, minorAsyncCall: false },
  importStudents: { aSyncCall: false, students: [] },
  studentsList: {
    aSyncCall: false,
    count: 0,
    entities: { students: {} },
    result: [],
  },
  schoolsList: {
    aSyncCall: false,
    count: 0,
    entities: { schools: {} },
    result: [],
  },
  teachersList: {
    aSyncCall: false,
    count: 0,
    entities: { teachers: {} },
    result: [],
  },
  supervisorsList: {
    count: 0,
    aSyncCall: false,
    entities: { supervisors: {} },
    result: [],
  },
  appsList: { aSyncCall: false, count: 0, entities: { apps: {} }, result: [] },
  eventsList: { aSyncCall: false, entities: { event: {} }, result: [] },
  myEventsList: { aSyncCall: false, entities: { event: {} }, result: [] },
  myOnlineTestsList: { aSyncCall: false, entities: { test: {} }, result: [] },
  orders: { aSyncCall: false, entities: { order: {} }, result: [] },
  myCoursesList: {
    aSyncCall: false,
    entities: { courses: {}, contents: {} },
    result: [],
  },
  coursesList: { aSyncCall: false, entities: { course: {} }, result: [] },
  boughtCoursesList: {
    aSyncCall: false,
    entities: { courses: {} },
    result: [],
  },
  courseContentsList: {
    aSyncCall: false,
    entities: { contents: {} },
    result: [],
  },
  student: { documents: { entities: {}, result: [] }, docAsync: false },
  school: {
    students: {
      entities: { educationalLevels: {}, grades: {}, students: {} },
      result: [],
    },
    schoolAsync: false,
  },
  supervisor: {
    students: {
      entities: { educationalLevels: {}, grades: {}, students: {} },
      result: [],
    },
    supervisorAsync: false,
  },
  messages: {
    received: { entities: { messages: {} }, result: [], isEverSynced: false },
    sent: { entities: { messages: {} }, result: [], isEverSynced: false },
    broadcasts: {
      entities: { broadcasts: {} },
      result: [],
      isEverSynced: false,
      count: 0,
    },
    notification: { entities: { messages: {} }, result: [] },
    newBroadcasts: { entities: { messages: {} }, result: [] },
    emails: { entities: { emails: {} }, result: [] },
    smsMessages: { entities: { smsMessages: {} }, result: [] },
    aSyncCall: false,
  },
  grades: [],
  levels: [],
  academicYears: [],
  courseTopics: [],
  educationalLevels: [],
  cities: [],
  states: [],
  userBalance: {
    aSyncCall: false,
    balance: null,
    rechargeRequestAsyncCall: false,
  },
  userStats: { aSyncCall: false, stats: {} },
  questions: { aSyncCall: false, entities: { question: {} }, result: [] },
  onlineTests: { aSyncCall: false, entities: { test: {} }, result: [] },
  testToTake: {
    aSyncCall: false,
    result: null,
    entities: { test: {}, topic: {}, question: {} },
  },
  answersStash: { answers: {} },
  testResult: { aSyncCall: false, result: {} },
  questionStash: {
    aSyncCall: false,
    questionsByTopic: {},
    successfullySubmittedQuestions: [],
  },
  testMakerQuestionsCache: { aSyncCall: false, questionsByTopic: {} },
  userCertificates: {
    aSyncCall: false,
    entities: { certificate: {} },
    result: [],
  },
  schoolTypes: defaultSchoolTypes,
  featuredItems: {
    aSyncCall: false,
  },
  contacts: [],
  eventCategories: {
    isLoading: false,
    list: [],
  },
  eventTemplates: {
    isLoading: false,
    badges: [],
    certificates: [],
    appreciations: [],
  },
  paymentMethods: {
    isLoading: false,
    list: [{ title: 'درگاه بانک پاسارگاد', id: 'pasargad' }],
  },
}



// WEBPACK FOOTER //
// ./src/store/defaultState.js